import { Component, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { DatePickerCustomHeaderComponent } from '../../date-picker-custom-header/date-picker-custom-header.component';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CommissionStateMatcher } from 'src/app/core/services/common.service';
import { adspCommission } from 'src/app/models/user';
import { AdvertiserService } from 'src/app/core/services/advertiser.service';
import { AgencyAdvertiserService, AgencyService } from 'src/app/core/services/agency.service';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { OfflineEntryTypes } from 'src/app/models/advertiser';
import { MatDialog } from '@angular/material/dialog';
import { InformationBoxComponent } from 'src/app/shared/information-box/information-box.component';
import { AppConfig } from 'src/app/configs/app.config';
import { NotificationService } from 'src/app/notification.service';
import { Observable } from 'rxjs';
import { tdspAdTypes } from 'src/app/models/tdsp/tdsp-insertion-order';

@Component({
  selector: 'app-commission',
  templateUrl: './commission.component.html',
  styleUrls: ['./commission.component.scss']
})
export class CommissionComponent implements OnInit {

  @Output() step_change = new EventEmitter<any>();
  @Input() step_input: any;
  datePickerHeader = DatePickerCustomHeaderComponent;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  matcher = new CommissionStateMatcher();
  minDate: Date;

  editPermission: boolean = true;

  isCommissionValid: boolean = false;
  isEdit: boolean;
  dspType: string;
  adspRegion: string;
  clientType: string;
  clientId: string = null;
  clientService;
  commission: adspCommission;
  commissionData;
  pageSize: number;
  pageIndex: number;
  dataPageLength: number;
  minCommission: number;
  maxCommission: number;
  commissionLabel: string;
  clientTimeZone: string;
  activeCommission;
  active_us_commission;
  active_eu_commission;
  agcAdv: boolean = false;

  commissionEntities: Array<any> = OfflineEntryTypes;
  commissionEntry: string = 'percentage_on_mc'
  commissionType: string;

  adTypes: Array<any> = tdspAdTypes;
  adType: string = "banner";

  allCommissionData: any[] = [];
  allActiveCommission: any = {};
  commissionForm: UntypedFormGroup;
  @ViewChild('commissionHistoryPaginator') paginatorCommissionHistory: MatPaginator;
  @ViewChild('commissionHistorySort') sortCommissionHistory: MatSort;
  commissionHistoryDataSource = new MatTableDataSource();
  displayAdspColumns: string[] = ['start_date', 'end_date', 'commission'];
  readonly whiteLabelMode: boolean;

  commissionName = {
    'vdsp-asf': 'Global Audiences & Inventory',
    'adsp-asf': 'Amazon Audiences & Inventory',
    'bdsp-asf': 'Restricted Inventory',
    'tdsp-asf': 'Trade Desk',
    'hyperlocal-asf': 'Hyperlocal'
  }

  adServiceFee = new Set(['vdsp-asf', 'adsp-asf', 'bdsp-asf', 'tdsp-asf', 'hyperlocal-asf']);
  commissionMap: Object = {};
  agencyId;
  isCreatedToday: boolean = false;

  constructor(
    private advertiserService: AdvertiserService,
    private agencyService: AgencyService,
    private agencyAdvertiserService: AgencyAdvertiserService,
    private tostr: NotificationService,
    private formBuilder: UntypedFormBuilder,
    private dialog: MatDialog
  ) {
    this.commission = new adspCommission();
    this.whiteLabelMode = AppConfig.WHITE_LABEL_MODE;
   }

  ngOnInit(): void {
    this.isEdit = this.step_input.isEdit;
    this.dspType = this.step_input.dsp;
    this.adspRegion = this.step_input.adspRegion || null;
    this.clientId = this.step_input.clientId;
    this.agencyId = this.step_input.includeAdvertiserParams ? this.clientId : null;
    this.clientType = this.step_input.clientType;
    this.editPermission = this.step_input.editPermission;
    this.commissionType = this.step_input.commissionType;
    this.commissionLabel = this.step_input.commissionLabel;
    this.isCreatedToday = this.step_input.isCreatedToday;
    this.agcAdv = this.step_input.agcAdv;
    if (this.commissionType === 'tdsp_cpm_comm' || this.commissionType === 'tdsp_cpc_comm' || this.commissionType === 'hyperlocal_cpm_comm' || this.commissionType === 'hyperlocal_cpc_comm') {
      this.displayAdspColumns = ['start_date', 'end_date', 'ad_type', 'commission'];
    }
    if((this.commissionType == 'tdsp_cpm_comm' || this.commissionType == 'tdsp_cpc_comm' || this.commissionType == 'hyperlocal_cpm_comm' || this.commissionType == 'hyperlocal_cpc_comm') && this.clientType == 'agency_advertiser'){
      this.adTypes = this.adTypes.filter(adType => (this.step_input.allowed_ad_types || []).some((item: any) => item.ad_type === adType.value));
    }
    if (this.commissionType === 'hyperlocal_cpm_comm' || this.commissionType === 'hyperlocal_cpc_comm') {
      this.adTypes = tdspAdTypes.filter(adType => ['banner', 'video'].includes(adType.value));
    }
    this.clientTimeZone = this.step_input.timezone;
    this.activeCommission = this.step_input.active_commission;
    this.clientService = this.clientType == 'advertiser' ? this.advertiserService : this.clientType ==
      'agency_advertiser' ? this.agencyAdvertiserService : this.agencyService;
    this.minCommission = this.step_input.commissionMin;
    this.maxCommission = this.step_input.commissionMax;
    this.updateMinCommissionByAdType();
    if (this.dspType == 'adsp_us' || this.dspType == 'adsp_eu') {
      this.setAdspMinDate();
    } else {
      this.setMinDate()
    }
    this.getCommissionMethod();
    if(this.isEdit) {
      this.commissionForm = this.formBuilder.group({
        commission: [
          {
            value: "",
            disabled:
              this.commissionLabel == "System Deal Commission"
                ? !this.editPermission || this.whiteLabelMode
                : !this.editPermission,
          },
          [Validators.required, this.validateEntries()],
        ],
        date: [
          {
            value: "",
            disabled:
              this.commissionLabel == "System Deal Commission"
                ? !this.editPermission || this.whiteLabelMode
                : !this.editPermission,
          },
          [Validators.required, this.dateCheck()],
        ],
      });
    }
    else{
      this.commissionForm = this.formBuilder.group({
        commission: [
          {
            value: "",
            disabled:
              this.commissionLabel == "System Deal Commission"
                ? !this.editPermission || this.whiteLabelMode
                : !this.editPermission,
          },
          [Validators.required, this.validateEntries()],
        ],
        date: [
          {
            value: "",
            disabled:
              this.commissionLabel == "System Deal Commission"
                ? !this.editPermission || this.whiteLabelMode
                : !this.editPermission,
          },
        ],
      });
    }
    if(this.step_input.clientType == 'agency_advertiser' && this.step_input.commissionType !== 'bdsp_agc_comm'){
      this.setDisabledStateForCpmCpc();
    }
  }

  setDisabledStateForCpmCpc(){
    if(!this.step_input?.cpmCpcEditAllowed){
      this.commissionForm?.get('commission').disable();
      this.commissionForm?.get('date').disable();
    }
  }

  getCommissionMethod() {
    interface CommissionConfig {
      get?: () => Observable<any>;
      set?: () => Observable<any>;
      successMsg?: string;
    }

    this.commissionMap = {
      adsp_cc: {
        get: () => this.clientService.getAdspContractCommission(this.clientId, { region: this.adspRegion }),
        set: () => this.clientService.setAdspContractCommission(this.clientId, this.commission),
        successMsg: `${this.adspRegion} Amazon Audiences & Inventory Contract commission is updated`,
      },
      adsp_sc: {
        get: () => this.clientService.getAdspSystemCommission(this.clientId, { region: this.adspRegion }),
        set: () => this.clientService.setAdspSystemCommission(this.clientId, this.commission),
        successMsg: `${this.adspRegion} Amazon Audiences & Inventory System commission is updated`,
      },
      adsp_dc: {
        get: () => this.clientService.getAdspDataCommission(this.clientId, { region: this.adspRegion }),
        set: () => this.clientService.setAdspDataCommission(this.clientId, this.commission),
        successMsg: `${this.adspRegion} Amazon Audiences & Inventory Data commission is updated`,
      },
      adsp_dl: {
        get: () => this.clientService.getAdspDealCommission(this.clientId, { region: this.adspRegion }),
        set: () => this.clientService.setAdspDealCommission(this.clientId, this.commission),
        successMsg: `${this.adspRegion} Amazon Audiences & Inventory Deal commission is updated`,
      },
      vdsp_cdc: {
        get: () => this.clientService.getPrivateDealCommission(this.clientId),
        set: () => this.clientService.setPrivateDealCommission(this.clientId, this.commission),
        successMsg: 'Global Audiences & Inventory - Old Contract Deal commission is updated',
      },
      vdsp_sdc: {
        get: () => this.clientService.getRegularDealCommission(this.clientId),
        set: () => this.clientService.setRegularDealCommission(this.clientId, this.commission),
        successMsg: 'Global Audiences & Inventory - Old System Deal commission is updated',
      },
      vdsp_oc: {
        get: () => this.clientService.getOfflineCommission(this.clientId),
        set: () => {
          this.commission['dsp_type'] = 'vizibl_dsp';
          this.commission['commission_type'] = this.commissionEntry;
          return this.clientService.setOfflineCommission(this.clientId, this.commission);
        },
        successMsg: 'Global Audiences & Inventory - Old offline commission is updated',
      },
      bdsp_cc: {
        get: () => this.clientService.getBdspContractCommission(this.clientId),
        set: () => this.clientService.setBdspContractCommission(this.clientId, this.commission),
        successMsg: 'Restricted Inventory Contract commission is updated',
      },
      bdsp_sc: {
        get: () => this.clientService.getBdspSystemCommission(this.clientId),
        set: () => this.clientService.setBdspSystemCommission(this.clientId, this.commission),
        successMsg: 'Restricted Inventory System commission is updated',
      },
      bdsp_dc: {
        get: () => this.clientService.getBdspDataCommission(this.clientId),
        set: () => this.clientService.setBdspDataCommission(this.clientId, this.commission),
        successMsg: 'Restricted Inventory Data commission is updated',
      },
      bdsp_cdc: {
        get: () => this.clientService.getBdspContractDealCommission(this.clientId),
        set: () => this.clientService.setBdspContractDealCommission(this.clientId, this.commission),
        successMsg: 'Restricted Inventory Contract Deal commission is updated',
      },
      bdsp_sdc: {
        get: () => this.clientService.getBdspSystemDealCommission(this.clientId),
        set: () => this.clientService.setBdspSystemDealCommission(this.clientId, this.commission),
        successMsg: 'Restricted Inventory System Deal commission is updated',
      },
      bdsp_agency_comm: {
        get: () =>
          this.clientService.getBdspAgencyCommission(this.clientId),
        set: () =>
          this.clientService.setBdspAgencyCommission(
            this.clientId,
            this.commission
          ),
        successMsg:
          "Restricted Inventory Agency commission is updated",
      },

      bdsp_agc_comm: {
        get: () =>
          this.clientService.getBdspAgencyAdvCommission(this.clientId, { agency_advertiser_id: this.clientId }),
        set: () =>
          this.clientService.setBdspAgencyAdvCommission(
            this.clientId,
            this.commission,
            { agency_advertiser_id: this.clientId }
          ),
        successMsg:
          "Restricted Inventory Agency commission is updated",
      },
      tdsp_cc: {
        get: () => this.clientService.getTdspContractCommission(this.clientId),
        set: () => this.clientService.setTdspContractCommission(this.clientId, this.commission),
        successMsg: 'Global Audiences & Inventory Contract commission is updated',
      },
      tdsp_sc: {
        get: () => this.clientService.getTdspSystemCommission(this.clientId),
        set: () => this.clientService.setTdspSystemCommission(this.clientId, this.commission),
        successMsg: 'Global Audiences & Inventory System commission is updated',
      },
      tdsp_dc: {
        get: () => this.clientService.getTdspDataCommission(this.clientId),
        set: () => this.clientService.setTdspDataCommission(this.clientId, this.commission),
        successMsg: 'Global Audiences & Inventory Data commission is updated',
      },
      tdsp_cdc: {
        get: () => this.clientService.getTdspContractDealCommission(this.clientId),
        set: () => this.clientService.setTdspContractDealCommission(this.clientId, this.commission),
        successMsg: 'Global Audiences & Inventory Contract Deal commission is updated',
      },
      tdsp_sdc: {
        get: () => this.clientService.getTdspSystemDealCommission(this.clientId),
        set: () => this.clientService.setTdspSystemDealCommission(this.clientId, this.commission),
        successMsg: 'Global Audiences & Inventory System Deal commission is updated',
      },
      tdsp_agency_comm: {
        get: () =>
          this.clientService.getTdspAgencyCommission(this.clientId, this.agencyId ? { agency_advertiser_id: this.agencyId } : {} ),
        set: () =>
          this.clientService.setTdspAgencyCommission(
            this.clientId,
            this.commission,
             this.agencyId ? { agency_advertiser_id: this.agencyId } : {}
          ),
        successMsg:
          "Global Audiences & Inventory Agency commission is updated",
      },
      tdsp_cpm_comm: {
        get: () => this.clientService.getTdspCpmCommission(this.clientId,this.agencyId ? { agency_advertiser_id: this.agencyId } : {}),
        set: () => this.clientService.setTdspCpmCommission(this.clientId, this.commission, this.adType,  this.agencyId ? { agency_advertiser_id: this.agencyId } : {}),
        successMsg: 'Global Audiences & Inventory CPM commission is updated',
      },
      tdsp_cpc_comm: {
        get: () => this.clientService.getTdspCpcCommission(this.clientId, this.agencyId ? { agency_advertiser_id: this.agencyId } : {}),
        set: () => this.clientService.setTdspCpcCommission(this.clientId, this.commission, this.adType, this.agencyId ? { agency_advertiser_id: this.agencyId } : {}),
        successMsg: 'Global Audiences & Inventory CPC commission is updated',
      },
      hyperlocal_cc: {
        get: () => this.clientService.getHyperlocalContractCommission(this.clientId),
        set: () => this.clientService.setHyperlocalContractCommission(this.clientId, this.commission),
        successMsg: 'Hyperlocal Contract commission is updated',
      },
      hyperlocal_sc: {
        get: () => this.clientService.getHyperlocalSystemCommission(this.clientId),
        set: () => this.clientService.setHyperlocalSystemCommission(this.clientId, this.commission),
        successMsg: 'Hyperlocal System commission is updated',
      },
      hyperlocal_dc: {
        get: () => this.clientService.getHyperlocalDataCommission(this.clientId),
        set: () => this.clientService.setHyperlocalDataCommission(this.clientId, this.commission),
        successMsg: 'Hyperlocal System Data commission is updated',
      },
      hyperlocal_cdc: {
        get: () => this.clientService.getHyperlocalContractDealCommission(this.clientId),
        set: () => this.clientService.setHyperlocalContractDealCommission(this.clientId, this.commission),
        successMsg: 'Hyperlocal Contract Deal commission is updated',
      },
      hyperlocal_sdc: {
        get: () => this.clientService.getHyperlocalSystemDealCommission(this.clientId),
        set: () => this.clientService.setHyperlocalSystemDealCommission(this.clientId, this.commission),
        successMsg: 'Hyperlocal System Deal commission is updated',
      },
      hyperlocal_agency_comm: {
        get: () =>
          this.clientService.getHyperlocalAgencyCommission(this.clientId, this.agencyId ? { agency_advertiser_id: this.agencyId } : {} ),
        set: () =>
          this.clientService.setHyperlocalAgencyCommission(
            this.clientId,
            this.commission,
            this.agencyId ? { agency_advertiser_id: this.agencyId } : {}
          ),
        successMsg:
          "Hyperlocal Agency commission is updated",
      },
      hyperlocal_cpm_comm: {
        get: () => this.clientService.getHyperlocalCpmCommission(this.clientId, this.agencyId ? { agency_advertiser_id: this.agencyId } : {}),
        set: () => this.clientService.setHyperlocalCpmCommission(this.clientId, this.commission, this.adType, this.agencyId ? { agency_advertiser_id: this.agencyId } : {}),
        successMsg: 'Hyperlocal CPM commission is updated',
      },
      hyperlocal_cpc_comm: {
        get: () => this.clientService.getHyperlocalCpcCommission(this.clientId, this.agencyId ? { agency_advertiser_id: this.agencyId } : {}),
        set: () => this.clientService.setHyperlocalCpcCommission(this.clientId, this.commission, this.adType, this.agencyId ? { agency_advertiser_id: this.agencyId } : {}),
        successMsg: 'Hyperlocal CPC commission is updated',
      },
    };
    this.getCommission();
  }

  getCurrencyFee() {
    return `Fee (${this.step_input.currency}) `;
  }

  getCurrencyFeeLegacy(){
    return `Agreed ${this.commissionLabel.includes('CPM') ? 'CPM' : 'CPC'} (${this.step_input.currency}) `;
  }

  getActiveCommission() {
    const isCpmCpc = this.commissionType === 'tdsp_cpm_comm' || this.commissionType === 'tdsp_cpc_comm' || this.commissionType === 'hyperlocal_cpm_comm' || this.commissionType === 'hyperlocal_cpc_comm';
    if (isCpmCpc) {
      const currency = this.clientType === 'agency_advertiser' ? this.step_input.currency : '$';
      const adTypeLabel = this.adTypes.find(t => t.value === this.adType)?.label || this.adType;
      return `${adTypeLabel}: ${currency} ${this.activeCommission}`;
    }
    return this.adServiceFee.has(this.commissionType)
      ? this.step_input.currency + " " + this.activeCommission
      : this.activeCommission + " %";
  }

  getCurrency() {
    return `(${this.step_input.currency})`;
  }

  setMinDate() {
    let today = new Date().toLocaleString('en-US', {
      timeZone: this.clientTimeZone,
    })
    this.minDate = new Date(today)
    this.minDate.setDate(this.minDate.getDate() + 1)
    this.minDate.setHours(0, 0, 0, 0)
  }

  setAdspMinDate(){
    let today = new Date().toLocaleString('en-US', {
      timeZone: 'UTC',
    })
    this.minDate = new Date(today)
    this.minDate.setDate(this.minDate.getDate() + 1)
    this.minDate.setHours(0, 0, 0, 0)
  }

  dateCheck() {
    return (control: AbstractControl): ValidationErrors | null => {
      var isPast: Boolean = false
      var date = control.value
      let minComparableDate = this.minDate
      isPast = this.isPastDate(date, minComparableDate)
      return isPast ? { pastDate: true } : null
    };
  }

  isPastDate(date, matchWith) {
    if (!this.isEdit) {
      return;
    }
    return date < matchWith
  }

  getDateObjectfromString(dateString) {
    dateString = dateString.replace(' ', 'T');
    var dateObj = new Date(dateString);
    return dateObj;
  }

  getDateStringFromObject(dateObject) {
    var dateTimeStr = new Date(dateObject.getTime() - dateObject.getTimezoneOffset() * 60000).toISOString();
    var dateStr = dateTimeStr.split('T')[0]
    return `${dateStr}`;
  }

  handlePageEvent(event: PageEvent) {
    this.dataPageLength = event.length;
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    let requested_page = event.pageSize * (event.pageIndex + 1)
    if (requested_page > this.commissionData.length) {
      let params = {
        start_element: event.pageSize >= this.commissionData.length ? event.pageSize : this.commissionData.length,
        num_elements: 100
      }
    }
  }

  updateTable() {
    this.commissionHistoryDataSource = new MatTableDataSource(this.commissionData);
    this.commissionHistoryDataSource.sort = this.sortCommissionHistory
    this.commissionHistoryDataSource.paginator = this.paginatorCommissionHistory;
    this.commissionHistoryDataSource._updatePaginator(this.dataPageLength);
  }

  handleCommissionResponse(res: any): void {
    const isCpmCpc = this.commissionType === 'tdsp_cpm_comm' || this.commissionType === 'tdsp_cpc_comm' ||
                     this.commissionType === 'hyperlocal_cpm_comm' || this.commissionType === 'hyperlocal_cpc_comm';

    this.allCommissionData = res.data;

    if (isCpmCpc) {
      this.allActiveCommission = res.active_commission;
      this.commissionData = this.allCommissionData.filter(item => item.ad_type === this.adType);
      this.activeCommission = this.allActiveCommission[this.adType]?.['commission'];
    } else {
      this.commissionData = this.allCommissionData;
      this.activeCommission = res.active_commission['commission'];
    }

    this.dataPageLength = this.commissionData.length;

    const last = this.commissionData[this.commissionData.length - 1]
      ?? res.data[res.data.length - 1];

    this.commission.commission = last?.["commission"];
    this.commission.start_date = last?.["start_date"]
      ? this.getDateObjectfromString(last["start_date"])
      : null;

    if (last?.["commission_type"]) {
      this.commissionEntry = last["commission_type"];
    }

    this.updateTable();
  }

  getCommission(){
    if (this.adServiceFee.has(this.commissionType)) {
      this.clientService
        .getAdServiceFee(
          this.clientId,
          this.commissionType,
          this.adspRegion ? { region: this.adspRegion } : {}
        )
        .subscribe(
          (res) => this.handleCommissionResponse(res),
          () => {},
          () => this.validateCommission()
        );
      return;
    }

    const config = this.commissionMap[this.commissionType];
    config?.get?.().subscribe(
      (res) => this.handleCommissionResponse(res),
      () => {},
      () => this.validateCommission()
    );
  }

  filterByAdType() {
    this.updateMinCommissionByAdType();
    this.commissionData = this.allCommissionData.filter(item => item.ad_type === this.adType);
    this.dataPageLength = this.commissionData.length;

    const last = this.commissionData[this.commissionData.length - 1];
    this.commission.commission = last?.["commission"];
    this.commission.start_date = last?.["start_date"]
      ? this.getDateObjectfromString(last["start_date"])
      : null;
    this.activeCommission = this.allActiveCommission[this.adType]?.['commission'];

    this.updateTable();
  }

  handleCommissionUpdateResponse(res: any): void {
    if (this.commissionType === 'tdsp_cpm_comm' || this.commissionType === 'tdsp_cpc_comm' || this.commissionType === 'hyperlocal_cpm_comm' || this.commissionType === 'hyperlocal_cpc_comm') {
      this.getCommission();
      return;
    }
    const last = res.data[res.data.length - 1];
    this.commissionData = res.data;
    this.dataPageLength = res.data.length;
    this.commission.commission = last['commission'];
    this.commission.start_date = this.getDateObjectfromString(last['start_date']);
    this.activeCommission = res.active_commission['commission'];
    this.updateTable();
  }


  setCommission() {
    this.commission.start_date = this.getDateStringFromObject(
      this.commission.start_date
    );

    this.commission["activate_immediately"] = false;

    if (this.adspRegion && this.commissionType.startsWith("adsp")) {
      this.commission["region"] = this.adspRegion;
    }

    if (this.adServiceFee.has(this.commissionType)) {
      this.clientService
        .setAdServiceFee(this.clientId, this.commissionType, this.commission)
        .subscribe(
          (res) => this.handleCommissionUpdateResponse(res),
          () => {
            this.commission.start_date = this.getDateObjectfromString(
              this.commission.start_date
            );
          },
          () => {
            this.tostr.success(
              `${this.adspRegion ? this.adspRegion + " " : ""}${
                this.commissionName[this.commissionType]
              } Ad serving fee is updated`
            );
          }
        );

      return;
    }

    const config = this.commissionMap[this.commissionType];
    if (config?.set) {
      config.set().subscribe(
        (res) => {
          this.handleCommissionUpdateResponse(res);
          this.tostr.success(config.successMsg || "Commission updated");
        },
        () => {
          this.commission.start_date = this.getDateObjectfromString(
            this.commission.start_date
          );
        }
      );
    }
  }

  setImmediateCommission() {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    this.commission.start_date = this.getDateStringFromObject(tomorrow);

    this.commission["activate_immediately"] = true;

    if (this.adspRegion && this.commissionType.startsWith("adsp")) {
      this.commission["region"] = this.adspRegion;
    }

    if (this.adServiceFee.has(this.commissionType)) {
      this.clientService
        .setAdServiceFee(this.clientId, this.commissionType, this.commission)
        .subscribe(
          (res) => this.handleCommissionUpdateResponse(res),
          () => {
            this.commission.start_date = this.getDateObjectfromString(
              this.commission.start_date
            );
          },
          () => {
            this.tostr.success(
              `${this.adspRegion ? this.adspRegion + " " : ""}${
                this.commissionName[this.commissionType]
              } Ad serving fee is updated`
            );
          }
        );

      return;
    }

    const config = this.commissionMap[this.commissionType];
    if (config?.set) {
      config.set().subscribe(
        (res) => {
          this.handleCommissionUpdateResponse(res);
          this.tostr.success(config.successMsg || "Commission updated");
        },
        () => {
          this.commission.start_date = this.getDateObjectfromString(
            this.commission.start_date
          );
        }
      );
    }
  }

  showCommissionSetup() {
    let dialog = this.dialog.open(InformationBoxComponent, {
      width: "60%",
      autoFocus: false,
      panelClass: "information-modalbox",
      disableClose: true,
      data: {
        type: "offlineCommission",
      },
    });
  }

  get isAdTypeEmpty(): boolean {
    const isCpmCpc = this.commissionType === 'tdsp_cpm_comm' || this.commissionType === 'tdsp_cpc_comm' ||
                     this.commissionType === 'hyperlocal_cpm_comm' || this.commissionType === 'hyperlocal_cpc_comm';
    return isCpmCpc && this.adTypes.length === 0;
  }

  validateCommission() {
    this.isCommissionValid = true;
    if (this.isPastDate(this.commission.start_date, this.minDate)) {
      this.isCommissionValid = false;
    }

    if (!this.commission.start_date) {
      this.isCommissionValid = false;
    }

    if (this.commission.commission < this.minCommission || this.commission.commission > this.maxCommission || this.commission.commission == null) {
      this.isCommissionValid = false;
    }

    if(this.countDecimals(this.commission.commission) > 2){
      this.isCommissionValid = false;
    }
  }

  validateEntries() {
    return (control: AbstractControl): ValidationErrors | null => {
      const validInteger = {};
      const value = control.value
      if(value) {
        if (this.countDecimals(value) > 2){
          validInteger['float'] = true;
        }
      }
      return validInteger;
    };
  }

  countDecimals(value) {
    if (Math.floor(value) == value) return 0;
    else {
      return value.toString().split(".")[1].length || 0;
    }
  }

  updateMinCommissionByAdType() {
    if (
      this.clientType === 'agency_advertiser' &&
      this.step_input.allowed_ad_types
    ) {
      const match = this.step_input.allowed_ad_types.find(
        (item: any) => item.ad_type === this.adType
      );

      if (match) {
        this.minCommission = match.commission;
      }
    }
  }

}
